var React = require('react');

function MacSpoofing (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"MAC Spoofing","clipPath":"url(#clip0_72_91124)","key":0},React.createElement("path",{"id":"Combined Shape","fillRule":"evenodd","clipRule":"evenodd","d":"M20 0H16V6H12C8.68629 6 6 8.68629 6 12V16H0V20H6V31H0V35H6V36C6 39.3137 8.68629 42 12 42H16V48H20V42H28V48H32V42H36C39.3137 42 42 39.3137 42 36V35H48V31H42V20H48V16H42V12C42 8.68629 39.3137 6 36 6H32V0H28V6H20V0ZM10 10H38V38H10V10Z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_72_91124"},React.createElement("rect",{"width":"48","height":"48","fill":"white"})))]);
}

MacSpoofing.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = MacSpoofing;

MacSpoofing.default = MacSpoofing;
